import { createSelector } from "reselect";

const keycloak = (state: any) => {
    return state.get('keycloak');
};

const keycloakSelector = createSelector([keycloak], (payload: any) => {
        const {keycloak} = payload.toJS();
        return keycloak;
});


export {
    keycloakSelector
};
